import { render } from "./FixOrderModal.vue?vue&type=template&id=5956d91d&scoped=true"
import script from "./FixOrderModal.vue?vue&type=script&lang=js"
export * from "./FixOrderModal.vue?vue&type=script&lang=js"

import "./FixOrderModal.vue?vue&type=style&index=0&id=5956d91d&scoped=true&lang=css"
import "./FixOrderModal.vue?vue&type=style&index=1&id=5956d91d&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5956d91d"]])

export default __exports__